import React, { useEffect } from 'react';
import { OpeningSection } from '../components/page/sections/OpeningSection';
import { ChallengeSection } from '../components/page/sections/ChallengeSection';
import { JourneySection } from '../components/page/sections/JourneySection';
import { WebsiteSection } from '../components/page/sections/WebsiteSection';
import { ChannelsSection } from '../components/page/sections/ChannelsSection';
import { UseCasesSection } from '../components/page/sections/UseCasesSection';
import { SignalsSection } from '../components/page/sections/SignalsSection';
import { CompoundSection } from '../components/page/sections/CompoundSection';
import { StationSection } from '../components/page/sections/StationSection';
import { CampaignSection } from '../components/page/sections/CampaignSection';
import { PageNav } from '../components/page/PageNav';
import { useActiveSection } from '../hooks/useActiveSection';
import { deckPages } from '../data/deck';

/** REKOVELLE × Snakker — from attention to action, as one scrolling page. */
export function Presentation() {
  const active = useActiveSection(deckPages.map(page => page.id));

  // Honour deep links like /#signals once the sections have rendered.
  useEffect(() => {
    const id = window.location.hash.slice(1);
    if (!id) return;
    const timer = window.setTimeout(() => {
      document.getElementById(id)?.scrollIntoView({
        block: 'start'
      });
    }, 80);
    return () => window.clearTimeout(timer);
  }, []);
  return <div className="w-full bg-[var(--surface)]" data-id="element-859" data-mp="1b5zizykziut6">
      <OpeningSection data-id="element-860" data-mp="1f3x5uura94te" />
      <ChallengeSection data-id="element-861" data-mp="1f3f2le67dqbz" />
      <JourneySection data-id="element-862" data-mp="1k4bf2g4mekt0" />
      <WebsiteSection data-id="element-863" data-mp="1k3tdd3z6vedp" />
      <ChannelsSection data-id="element-864" data-mp="1k5mk0j9sxylp" />
      <UseCasesSection data-id="element-865" data-mp="1k54h53smwm4t" />
      <SignalsSection data-id="element-866" data-mp="1p3e8f3b8n2l5" />
      <CompoundSection data-id="element-867" data-mp="1p3xpkht2dmy4" />
      <StationSection data-id="element-868" data-mp="1p238jekwyezb" />
      <CampaignSection data-id="element-869" data-mp="1p1bmaud7htlp" />
      <PageNav active={active} data-id="element-870" data-mp="3lvo92a51v8aa" />
    </div>;
}